<!--
 * @Author: Cathy
 * @Date: 2020-02-24 10:00:48
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-16 16:41:33
 * @Description: 联吧下载
 -->
<template>
  <div class="download">
    <!-- <topMenu pageType="recommend" /> -->
    <van-nav-bar :title="'联吧/' + title" />
    <div class="input_box">
      <van-icon name="arrow-left"
                size="16"
                color="#000"
                @click="goBack"
                style="margin: .1rem" />
      <div class="search_box"
           @click="tosearch">
        <input disabled
               class="search"
               type="text"
               placeholder="搜索视频 / 图文教程" />
        <div class="icon">
          <van-icon name="search"
                    color="#919191"
                    size="18" />
        </div>
      </div>
    </div>
    <div class="inner">
      <div class="list_box">
        <div class="box"
             @click="toLink()">
          <div class="title">{{lower.cate_name}}</div>
          <van-icon name="arrow"
                    color="#fff"
                    size="20" />
        </div>
      </div>
      <div class="big_box"
           @scroll.passive="scroll($event)">
        <div class="detail">
          <div class="tItem"
               v-for="(item, index) in list"
               :key="index"
               @click.stop="directionsDetail(item.h5_id,item.type)">
            <img :src="item.page_img" />
            <a :id="'title'+ index" />
            <p>{{index + 1}}.{{item.title}}</p>
          </div>
        </div>

      </div>
    </div>
    <isWeixinMark :isWeixin="isWeixin"
                  @onCancelMark="isWeixin = false" />
    <div class="downloadImage"
         @click="onDownload">
      <img src="../assets/images/xiazai_duan.png" />
    </div>
  </div>
</template>

<script>
// import topMenu from '../components/topMenu'
import isWeixinMark from '../components/isWeixinMark'
import { getList, getWapFirmList } from '../api/wap'
export default {
  name: 'download',
  components: {
    // topMenu,
    isWeixinMark
  },
  data () {
    return {
      downloadLink: '',
      isWeixin: false,
      page: 1,
      page_total: 1,
      list: [],
      id: '',
      key: '',
      cate_level: '',
      lower: {}
    }
  },
  created () {
    if (this.$route.query.id) this.id = this.$route.query.id
    if (this.$route.query.title) this.title = this.$route.query.title
    if (this.$route.query.key) this.key = this.$route.query.key
    if (this.$route.query.cate_level) this.cate_level = this.$route.query.cate_level
    this.lower = JSON.parse(localStorage.getItem('lower2'))
    // console.log(this.id);
    this.onLoadData()
    this.getlist()
  },
  methods: {
    onLoadData () {
      getList({ type: 1 }).then((res) => {
        this.downloadLink = res.result.download_url.android
      })
    },
    onDownload () {
      const u = window.navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
      const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIos) {
        location.href =
          'https://apps.apple.com/cn/app/%E8%81%94%E5%90%A7/id1404140841'
      }
      if (isAndroid) {
        this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1
        if (!this.isWeixin) {
          location.href = this.downloadLink
        }
      }
    },
    getlist () {
      getWapFirmList({
        page_now: this.page,
        cate_id: this.id,
        cate_level: this.cate_level
      }).then(res => {
        if (this.page === 1) {
          this.list = res.result.lists
        } else {
          this.list.push(...res.result.lists)
        };
        this.page_total = res.result.page_total
      })
    },
    goBack () {
      this.$router.back()
    },
    toLink () {
      this.$router.push({
        path: '/fullyGood',
        query: {
          id: this.lower.cate_id,
          cate_level: this.lower.cate_level,
          key: this.key,
          title: this.title
        }
      })
    },
    tosearch () {
      this.$router.push({
        path: '/search',
        query: {
          key: this.key
        }
      })
    },
    scroll (e) {
      let bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight
      if (bottom === 0) {
        if (this.page < this.page_total) {
          this.page++
          this.getlist()
        }
      }
    },
    directionsDetail (id, type) {
      if (type === 2 || type === '2') {
        this.$router.push({
          path: '/newDirectionsDetail',
          query: {
            id: id,
            key: this.key
          }
        })
      } else {
        this.$router.push({
          path: '/newVideoDetail',
          query: {
            id: id,
            key: this.key
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.downloadImage {
  /* margin-top: 1rem; */
  text-align: center;
  /* position: fixed;
  bottom: 0; */
  /* left: 0; */
  width: 100%;
  padding: 0.2rem 0 0.2rem;
  background: #ffff;
}
.downloadImage img {
  width: 6.5rem;
  height: 1.4rem;
}
.download {
  height: 100%;
  /* background-color: #f3f3f3; */
  display: flex;
  flex-direction: column;
}
.download >>> .van-nav-bar .van-icon {
  color: #000;
}
.search_box {
  width: 100%;
  background-color: #fff;
  padding: 0.2rem 0.2rem;
  position: relative;
  height: 1.1rem;
  display: flex;
}
.tips_box {
  margin-top: 0.24rem;
  font-size: 0.34rem;
  color: #121212;
  padding-left: 0.24rem;
}
.inner {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100vh;
}
.list_box {
  padding: 0 0.2rem 0;
  /* flex: 1; */
  overflow-y: auto;
}
.box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem;
  /* box-shadow: 0px 0px 0.46rem 0px rgba(0, 0, 0, 0.13); */
  margin-bottom: 0.26rem;
  min-height: 1.5rem;
  border-radius: 0.16rem;
  background-color: #faaa22;
}
.title {
  width: 5.45rem;
  font-size: 0.42rem;
  /* color: #121212; */
  font-weight: 500;
  line-height: 0.5rem;
  color: #fff;
}
.search {
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 0.3rem;
  font-size: 15px;
  background: #e7e7e7;
  border-radius: 0.35rem;
  border: none !important;
  line-height: 0.3rem;
}
.icon {
  position: absolute;
  top: 50%;
  right: 0.4rem;
  transform: translateY(-50%);
  align-items: center;
  height: 0.7rem;
  display: flex;
}
.big_box {
  flex: 1;
  /* background: red; */
  overflow: auto;
  margin-top: 0.46rem;
}
.detail {
  padding: 0 0.1rem 0;
  display: flex;
  flex-wrap: wrap;
  background: #fff;
}
.tItem {
  margin-bottom: 0.3rem;
  width: 3.45rem;
  border: 1px solid rgba(188, 188, 188, 1);
  border-radius: 0.1rem;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
  padding-bottom: 0.2rem;
}
.tItem p {
  color: #121212;
  font-size: 0.26rem;
  padding: 0 0.2rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.tItem img {
  width: 100%;
  height: 1.95rem;
  background-color: #121212;
}
.input_box {
  display: flex;
  align-items: center;
  padding-left: 0.2rem;
}
/* .downloadImage {
  text-align: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1.2rem 0;
  background: #f3f3f3;
}
.downloadImage img {
  width: 6.5rem;
  height: 1.4rem;
}
.download {
  height: 100vh;
  background-color: #f3f3f3;
  display: flex;
  flex-direction: column;
}
.van-hairline--bottom::after {
  border: none !important;
}
.input_box {
  padding: 0.2rem 0.4rem;
}
.search_box {
  width: 100%;
  position: relative;
  height: 0.9rem;
  display: flex;
  align-items: center;
}
.search_box .search {
  height: 100%;
  background: #fff;
  border-radius: 0.05rem;
  border: 1px solid rgba(216, 216, 216, 1);
  width: 100%;
  font-size: 0.28rem;
  padding: 0 0.2rem;
}
.search_box .icon {
  position: absolute;
  top: 50%;
  right: 0.2rem;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
}
.inner >>> .van-cell {
  align-items: center;
  font-size: 0.28rem !important;
  line-height: 0.4rem;
}
.inner {
  padding-bottom: 2rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.tips_box {
  font-size: 0.28rem;
  line-height: 0.6rem;
  padding-left: 0.2rem;
  display: flex;
  align-items: center;
}
.list_box {
  flex: 1;
  overflow: auto;
} */
/* .text {
  max-width: 2.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
} */
</style>
